// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"2f3f0cbf","678":"f0ad89de","963":"4d8599bd"}[chunkId] + ".chunk.js";
};